import { Injectable } from '@angular/core';
import { s } from '@fullcalendar/core/internal-common';

@Injectable({
  providedIn: 'root'
})
export class HelpService {

  constructor() { }

  public getResources() {
    return [
      {
        name: 'dashboard',
        module: 'dashboard',
        section: 'admin',
        resources: [
          { route: '-dashboard', title: 'Tablero de control', permission: 'modules.admin.dashboard.active' },
          { route: '-dashboard-show', title: 'Tablero de control Ver', permission: 'modules.admin.dashboard.active' },
        ]
      },
      {
        module: 'condominios',
        resources: [
          { route: '-condominios', title: 'Condominios', permission: 'modules.admin.settlements.active' },
          { route: '-condominios-edit-show', title: 'Condominios Editar / Ver', permission: 'modules.admin.settlement.active' },
          { route: '-condominios-create-condominio', title: 'Condominios Crear Condominio', permission: 'modules.admin.settlement.active' },
          { route: '-condominios-show', title: 'Condominios Ver', permission: 'modules.admin.settlement.active' },
          { route: '-condominios-show-unidad-show', title: 'Condominios Unidad Ver', permission: 'modules.admin.settlement.active' },
          { route: '-condominios-show-dashboard', title: 'Condominios Dashboard', permission: 'modules.admin.settlement.active' },
        ]
      },
      {
        name: 'comercials',
        module: 'comercials',
        section: 'admin',
        resources: [
          { route: '-comercials', title: 'Comercial', permission: 'modules.admin.comercial.active' },
          { route: '-comercials-pendientes', title: 'Comercial Editar / Ver', permission: 'modules.admin.comercial.active' },
          { route: '-comercials-create-condominio', title: 'Comercial Crear Condominio', permission: 'modules.admin.comercial.active' },
          { route: '-comercials-show', title: 'Comercial Ver', permission: 'modules.admin.comercial.active' },
          { route: '-comercials-show-unidad-show', title: 'Comercial Unidad Ver', permission: 'modules.admin.comercial.active' },
          { route: '-comercials-show-dashboard', title: 'Comercial Dashboard', permission: 'modules.admin.comercial.active' },
        ]
      },
      {
        name: 'pagos',
        section: 'billing',
        module: 'admin',
        imgs: [
          'assets/images/emitir.png',
          'assets/images/emitir.png'
        ],
        resources: [
          { route: '-pagos', title: 'Pagos realizados', permission: 'pagos' },
          { route: '-pagos-pendientes', title: 'Recibos no emitidos', permission: 'emitted' },
          { route: '-pagos-recibos-show', title: 'Consultar recibo', permission: 'emitted' },
          { route: '-pagos-recibos', title: 'Recibos no pagados', permission: 'nopago' },
          { route: '-pagos-balances', title: 'Saldos', permission: 'saldos' },
          { route: '-pagos-concepts', title: 'Conceptos', permission: 'conceptos' },
        ]
      },
      {
        name: 'roles',
        section: 'roles',
        module: 'operation',
        resources: [
          { route: '-roles', title: 'Roles', permission: 'roles' },
          { route: '-roles-show', title: 'Creación de Roles', permission: 'roles' },
          { route: '-roles-edit', title: 'Editar Roles', permission: 'roles' },
        ]
      }
    ];
  }

  public quickGuide(route: any) {
    return [
      {
        route: '-dashboard',
        title: 'Tablero de control',
        description: 'Accede al sistema de administración.',
        howto: [
          'Consulta la ubicación de los condominios/comercios en el mapa.',
          'Resumen de los condominios/comercios.',
          'Consulta Tareas de la semana',
          'Resumen de las tareas de programas, no asignadas y ordenes de suministros.',
        ]
      },
      {
        route: '-condominios',
        title: 'Condominios',
        description: 'Accede al sistema de administración de condominios.',
        howto: [
          'Accede al sistema de administración de condominios.',
          'Dirígete a la sección de "Condominios".',
          'Haz clic en el botón "Agregar".',
          'Completa los campos requeridos, como el nombre del condominio, la dirección y la información de contacto. Completa los campos requeridos (marcados con “*” asterisco).',
          'Guarda los cambios y confirma la creación del condominio.',
          'Realiza una consulta para verificar que el condominio se haya creado correctamente.',
        ]
      },
      {
        route: '-condominios-edit-show',
        title: 'Condominios Editar / Ver',
        description: 'Dirígete a la sección de "Condominios".',
        howto: [
          'Accede al sistema de administración de condominios.',
        ]
      },
      {
        route: '-comercials-edit-show',
        title: 'Editar Comercio',
        description: 'Resumen de la información generada por el comercio',
        howto: [
          'Accede al sistema de administración de comercial.',
        ]
      },
      {
        route: '-comercials-show',
        title: 'Detalle Comercio',
        description: 'Resumen de la información generada por el comercio',
        howto: [
          'Accede al sistema de administración de comercial.',
        ]
      },
      {
        route: '-comercials-show-dashboard',
        title: 'Tablero Comercio',
        description: 'Resumen de la información generada por el comercio',
        howto: [
          'Accede al sistema de administración de comercial.',
        ]
      },
      {
        route: '-pagos-pendientes',
        title: 'Pagos no emitidos',
        description: 'Haz clic en el botón "Agregar".',        
        howto: [
          'Accede al sistema de administración.',
          'Navega hasta la sección de Pagos→ Recibos no emitidos.',
          'Localiza la unidad o cliente para el cual deseas emitir el recibo.',
          'En el menú de la unidad, da clic en la opción Consultar Recibo',
          'El sistema calculará automáticamente el consumo de cada unidad con base en las lecturas de medidor ingresadas.',
          'Aplica las tarifas y políticas establecidas para calcular el importe a cobrar por los servicios utilizados.',
          'Revisa el importe calculado y verifica que sea correcto.',
          'Personaliza el recibo si es necesario, agregando conceptos adicionales al consumo de gas.',
          'Genera el recibo haciendo clic en el botón "Actualizar recibo"→ "Emitir Recibo".',
          'El recibo se generará en formato digital y estará listo para su entrega.',
        ]
      },
      {
        route: '-pagos-conceptos',
        title: 'Conceptos',
        description: 'Haz clic en el botón "Agregar".',        
        howto: [
          'Accede al sistema de administración.',
          'Navega hasta la sección de Pagos→ Recibos no emitidos.',
          'Localiza la unidad o cliente para el cual deseas emitir el recibo.',
          'En el menú de la unidad, da clic en la opción Consultar Recibo',
          'El sistema calculará automáticamente el consumo de cada unidad con base en las lecturas de medidor ingresadas.',
          'Aplica las tarifas y políticas establecidas para calcular el importe a cobrar por los servicios utilizados.',
          'Revisa el importe calculado y verifica que sea correcto.',
          'Personaliza el recibo si es necesario, agregando conceptos adicionales al consumo de gas.',
          'Genera el recibo haciendo clic en el botón "Actualizar recibo"→ "Emitir Recibo".',
          'El recibo se generará en formato digital y estará listo para su entrega.',
        ]
      },
      {
        route: '-invoices',
        title: 'Tablero facturas',
        description: 'Completa los campos requeridos, como el nombre del condominio, la dirección y la información de contacto. Completa los campos requeridos (marcados con “*” asterisco).',
        howto: []
      },
      {
        route: '-invoices-ingresos',
        title: 'Condominios',
        description: 'Guarda los cambios y confirma la creación del condominio.',
        howto: []
      },
      {
        route: '-invoices-complementos',
        title: 'Complementos',
        description: 'Realiza una consulta para verificar que el condominio se haya creado correctamente.',
        howto: []
      },
      {
        route: '-invoices-globales',
        title: 'Globales',
        description: 'Realiza una consulta para verificar que el condominio se haya creado correctamente.',
        howto: []
      },
      {
        route: '-invoices-creditnote',
        title: 'Nota de crédito',
        description: 'Realiza una consulta para verificar que el condominio se haya creado correctamente.',
        howto: []
      },
      {
        route: '-invoices-canceladas',
        title: 'Cancelaciones',
        description: 'Realiza una consulta para verificar que el condominio se haya creado correctamente.',
        howto: []
      },
      {
        route: '-inventory-vehicles',
        title: 'Condominios',
        description: 'Realiza una consulta para verificar que el condominio se haya creado correctamente.',
        howto: []
      },
      {
        route: '-inventory-skills',
        title: 'Condominios',
        description: 'Realiza una consulta para verificar que el condominio se haya creado correctamente.',
        howto: []
      },
      {
        route: '-inventory-tools',
        title: 'Condominios',
        description: 'Realiza una consulta para verificar que el condominio se haya creado correctamente.',
        howto: []
      },
      {
        route: '-reports',
        title: 'Condominios',
        description: 'Realiza una consulta para verificar que el condominio se haya creado correctamente.',
        howto: []
      },
      {
        route: '-maintenances',
        title: 'Condominios',
        description: 'Realiza una consulta para verificar que el condominio se haya creado correctamente.',
        howto: []
      },
      {
        route: '-maintenances-tasks',
        title: 'Condominios',
        description: 'Realiza una consulta para verificar que el condominio se haya creado correctamente.',
        howto: []
      },
      {
        route: '-maintenances-tasks-unassigned',
        title: 'Condominios',
        description: 'Realiza una consulta para verificar que el condominio se haya creado correctamente.',
        howto: []
      },
      {
        route: '-maintenances-tasks-suministro',
        title: 'Condominios',
        description: 'Realiza una consulta para verificar que el condominio se haya creado correctamente.',
        howto: []
      },
      {
        route: '-maintenances-builders',
        title: 'Condominios',
        description: 'Realiza una consulta para verificar que el condominio se haya creado correctamente.',
        howto: []
      },
      {
        route: '-maintenances-activities',
        title: 'Condominios',
        description: 'Realiza una consulta para verificar que el condominio se haya creado correctamente.',
        howto: []
      },
      {
        route: '-maintenances-activity-types',
        title: 'Condominios',
        description: 'Realiza una consulta para verificar que el condominio se haya creado correctamente.',
        howto: []
      },
      {
        route: '-maintenances-holidays',
        title: 'Condominios',
        description: 'Realiza una consulta para verificar que el condominio se haya creado correctamente.',
        howto: []
      },
      {
        route: '-services',
        title: 'Condominios',
        description: 'Realiza una consulta para verificar que el condominio se haya creado correctamente.',
        howto: []
      },
      {
        route: '-amenidades-calendario',
        title: 'Condominios',
        description: 'Realiza una consulta para verificar que el condominio se haya creado correctamente.',
        howto: []
      },
      {
        route: '-amenidades-solicitudes',
        title: 'Condominios',
        description: 'Realiza una consulta para verificar que el condominio se haya creado correctamente.',
        howto: []
      },
      {
        route: '-amenidades',
        title: 'Condominios',
        description: 'Realiza una consulta para verificar que el condominio se haya creado correctamente.',
        howto: []
      },
      {
        route: '-providers',
        title: 'Condominios',
        description: 'Realiza una consulta para verificar que el condominio se haya creado correctamente.',
        howto: []
      },
      {
        route: '-amenidades-solicitudes',
        title: 'Condominios',
        description: 'Realiza una consulta para verificar que el condominio se haya creado correctamente.',
        howto: []
      },
      {
        route: '-combustibles-tanques',
        title: 'Condominios',
        description: 'Realiza una consulta para verificar que el condominio se haya creado correctamente.',
        howto: []
      },
      {
        route: '-combustibles-tanques-gauge-show',
        title: 'Condominios',
        description: 'Realiza una consulta para verificar que el condominio se haya creado correctamente.',
        howto: []
      },
      {
        route: '-combustibles-refuels',
        title: 'Condominios',
        description: 'Realiza una consulta para verificar que el condominio se haya creado correctamente.',
        howto: []
      },
      {
        route: '-combustibles-orders',
        title: 'Condominios',
        description: 'Realiza una consulta para verificar que el condominio se haya creado correctamente.',
        howto: []
      },
      {
        route: '-combustibles-zonas',
        title: 'Condominios',
        description: 'Realiza una consulta para verificar que el condominio se haya creado correctamente.',
        howto: []
      },
      {
        route: '-technicians',
        title: 'Condominios',
        description: 'Realiza una consulta para verificar que el condominio se haya creado correctamente.',
        howto: []
      },
      {
        route: '-technicians-show',
        title: 'Condominios',
        description: 'Realiza una consulta para verificar que el condominio se haya creado correctamente.',
        howto: []
      },
      {
        route: '-users',
        title: 'Condominios',
        description: 'Realiza una consulta para verificar que el condominio se haya creado correctamente.',
        howto: []
      },
      {
        route: '-users-profile-show',
        title: 'Condominios',
        description: 'Realiza una consulta para verificar que el condominio se haya creado correctamente.',
        howto: []
      },
      {
        route: '-tenants',
        title: 'Condominios',
        description: 'Realiza una consulta para verificar que el condominio se haya creado correctamente.',
        howto: []
      },
      {
        route: '-tenants-edit-show',
        title: 'Condominios',
        description: 'Realiza una consulta para verificar que el condominio se haya creado correctamente.',
        howto: []
      },
      {
        route: '-perfiles',
        title: 'Condominios',
        description: 'Realiza una consulta para verificar que el condominio se haya creado correctamente.',
        howto: []
      },
      {
        route: '-perfiles-edit-show',
        title: 'Condominios',
        description: 'Realiza una consulta para verificar que el condominio se haya creado correctamente.',
        howto: []
      },
      {
        route: '-perfiles-dashboard-show',
        title: 'Condominios',
        description: 'Realiza una consulta para verificar que el condominio se haya creado correctamente.',
        howto: []
      },
      {
        route: '-roles',
        title: 'Roles',
        description: 'Permisos de la plataforma ZAZZ.',
        howto: [
          'Los permisos de la plataforma se pueden asignar por módulo.',
          'Cada permiso puede tener el de lectura y escritura.',
          'Los roles se agrupan por tipo de usuario.',
          'Cada rol puede ser creado con los permisos necesarios.',
        ]
      },
      {
        route: '-roles-create',
        title: 'Creación de Roles',
        description: 'Realiza una consulta para verificar que el condominio se haya creado correctamente.',
        howto: [
          'Cada módulo tiene permisos específicos que pueden activarse esto afectaría las opciones del menu.',
        ]
      },
      {
        route: '-roles-show',
        title: 'Edición de Roles',
        description: 'Realiza una consulta para verificar que el condominio se haya creado correctamente.',
        howto: [
          'Cada módulo tiene permisos específicos que pueden activarse esto afectaría las opciones del menu.',
        ]
      }
    ];
  }
}
